export interface LocationOptions {
  heading?: number;
  accuracy?: number;
}

export interface LocationPosition {
  lat: number;
  lng: number;
  floor?: string;
}

export interface LMPositionCallback {
  (position: GeolocationPosition, floor?: string): void;
}

export class MockGeolocationProvider implements Geolocation {
  private watchId = 1;

  private mockGeolocation:
    | ({ lat: number; lng: number; floor?: string } & LocationOptions)
    | null = null;

  public clearWatch(_watchId: number): void {}

  public getCurrentPosition(
    _successCallback: LMPositionCallback,
    _errorCallback?: PositionErrorCallback | null,
    _options?: PositionOptions,
  ): void {}

  public watchPosition(
    successCallback: LMPositionCallback,
    errorCallback?: PositionErrorCallback | null,
    _options?: PositionOptions,
  ): number {
    const currentWatchId = this.watchId;

    if (this.mockGeolocation)
      successCallback(
        {
          // @ts-ignore - toJSON type error is not going to be ussed
          coords: {
            latitude: this.mockGeolocation.lat,
            longitude: this.mockGeolocation.lng,
            accuracy: this.mockGeolocation.accuracy || 1,
            heading: this.mockGeolocation.heading || null,
            altitude: null,
            altitudeAccuracy: null,
            speed: null,
          },
          timestamp: 0,
        },
        this.mockGeolocation.floor,
      );
    else
      errorCallback &&
        errorCallback({
          code: GeolocationPositionError.POSITION_UNAVAILABLE,
          message: "Could not get position",
        } as GeolocationPositionError);

    this.watchId++;

    return currentWatchId;
  }

  public updateMockGeolocation(
    userPosition: LocationPosition,
    options?: LocationOptions | null,
  ): string {
    this.mockGeolocation = {
      lat: userPosition.lat,
      lng: userPosition.lng,
      floor: userPosition.floor,
      ...options,
    };
    return `User location updated to: (${userPosition.lat}, ${userPosition.lng})`;
  }
}
